module.exports = __webpack_public_path__ + "static/media/IMG_20181114_213249.4f05a2a9.jpg";